<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-09-18 10:31:09
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-06-18 16:16:20
 * @FilePath: /qd-yunjing-web/src/views/ibms/components/chartContent.vue
 * @Description: 这是默认设置,请设置`customMade`
-->
<template>
  <div class="chart-content-page">
    <base-chart
      v-if="chartResult && chartResult.length > 0"
      :options="option"
      height="100%"
      width="100%"
    />
    <el-empty
      v-else
      description="暂无数据"
    />
  </div>
</template>

<script>
  import { nextTick } from 'vue';
  import { formatDate } from '@/utils/index';

  export default {
    name: 'chart-content-page',

    props: {
      // 图表结果
      result: {
        type: Object,
        default: () => {},
      },
      // 已选设备列表
      equipments: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        chartResult: [],
        emptyList: [],
        chartType: 1,
        option: {},
      };
    },
    watch: {
      result: {
        immediate: true,
        deep: true,
        handler(newVal) {
          const charList = [];
          this.emptyList = [];
          Object.keys(newVal).forEach((key) => {
            let title = '';
            let order = 0;
            this.equipments.forEach((item, index) => {
              if (+item.shortPointId === +key) {
                title = item.pointType;
                order = index;
              }
            });

            const currentData = newVal[key];
            if (currentData.in) {
              charList.push({
                ...currentData,
                title,
                order,
              });
            } else {
              this.emptyList.push({
                ...currentData,
                title,
                order,
              });
            }
          });

          this.chartResult = [];

          nextTick(() => {
            this.chartResult = charList;
            this.initChar();
          });
        },
      },
    },
    methods: {
      initChar() {
        console.log('this.chartResult', this.chartResult);
        if (this.chartResult && this.chartResult.length) {
          let dateList = []; // x 轴时间信息
          const legendList = [];
          const valueList = []; // series 字段值
          const descList = []; // tooltip 中描述内容
          const chartType = this.chartType;
          const unit = this.chartResult[0].un;

          for (const cItem of this.chartResult) {
            if (cItem.in) {
              for (const item of cItem.in) {
                dateList.push(formatDate(item.ti));
              }
            }
          }

          dateList = [...new Set(dateList.sort())];

          const charData = [...this.chartResult].sort((x, y) => x.order - y.order);

          for (const item of charData) {
            descList.push({});
            if (item.in) {
              for (const iItem of item.in) {
                descList[descList.length - 1][formatDate(iItem.ti)] = iItem.d;
              }
            }

            legendList.push(item.title);
            if (item.ty === 'BOOL') {
              valueList.push({
                name: item.title,
                type: 'line',
                clip: true,
                smooth: true,
                showSymbol: false,
                data: item.in
                  ? item.in.map((val) => val.v)
                  : [],
              });
            } else {
              valueList.push({
                name: item.title,
                type: 'line',
                data: item.in
                  ? item.in.map((val) => [formatDate(val.ti), val.v])
                  : [],
              });
            }
          }
          this.$nextTick(() => {
            this.option = {
              color: ['#EB5757', '#F2994A', '#F2C94C', '#6FCF97', '#27AE60', '#219653', '#2F80ED',
                      '#2D9CDB', '#56CCF2', '#BA81CF', '#6D6BD9', '#CB83AA', '#FF9191', '#FFB26F',
                      '#FFA800', '#218196', '#0074B6', '#006B2E', '#285795', '#8CA870', '#B2A6E1',
                      '#6E51E0', '#99D1E3', '#BA3E3E', '#F9EAA0', '#B4976C', '#955B9A', '#D9D1A6',
                      '#97571C', '#95B3FF'],
              title: {
                show: true,
                text: this.title,
                textAlign: 'left',
                left: 12,
                top: 18,
                textStyle: {
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#000',
                },
              },
              tooltip: {
                trigger: 'axis',
                position(pos, params, dom, rect, size) {
                  // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
                  const obj = { top: 0 };
                  if (pos[0] + size.contentSize[0] + 10 > size.viewSize[0]) {
                    obj.left = pos[0] - size.contentSize[0] - 10;
                  } else {
                    obj.left = pos[0] + 10;
                  }
                  return obj;
                },
                formatter: (params) => {
                  console.log('params', params);
                  let str = params[0].name;
                  for (const item of params) {
                    str += `<br />${item.marker} ${item.seriesName}: ${descList[item.seriesIndex][item.name] || ''}`;
                  }

                  return str;
                },
              },
              grid: {
                left: 50,
                top: 50,
                right: 50,
                bottom: 30,
              },
              legend: {
                type: 'scroll',
                show: true,
                data: legendList,
                itemGap: 20,
              },
              xAxis: {
                type: 'category',
                data: dateList,
                min: 'dataMin',
              },
              yAxis: {
                minInterval: 1,
                type: 'value',
                min: 0,
                axisLabel: {
                  formatter: '{value}',
                },
              },
              series: valueList,
            };
          });
        }
      },
    },
  };
</script>
<style scoped>
.chart-content-page{
  width: 100%;
  height: 100%;
}
</style>
